import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { AppUiModule } from '../../ui/app-ui.module';
import { CurrentTimeComponent } from './work-shift/components/employee-statuses/current-time/current-time.component';
import {
  TicketsServicesComponent,
  ServicesModalComponent,
} from './work-shift/components/tickets-assign/components/tickets-services/tickets-services.component';
import { TicketsExtraComponent } from './work-shift/components/tickets-assign/components/tickets-extra/tickets-extra.component';
import { TicketCommunicatorInfoComponent } from './work-shift/components/tickets-assign/components/ticket-communicator-info/ticket-communicator-info.component';

@NgModule({
  imports: [CommonModule, AppUiModule, SharedModule],
  declarations: [
    TicketsServicesComponent,
    ServicesModalComponent,
    TicketsExtraComponent,
    CurrentTimeComponent,
    TicketCommunicatorInfoComponent,
  ],
  exports: [TicketsServicesComponent, ServicesModalComponent, TicketsExtraComponent, CurrentTimeComponent, TicketCommunicatorInfoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WorkShiftExpandedModule {}
